<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="schoolId" v-if="form.parentId==='0' ">
        <span slot="label"><a-tooltip>{{ $t('学校') }}<template slot="title">{{ $t('学校') }}</template></a-tooltip> </span>
        <a-select :placeholder="$t('请选择')+$t('学校')" style="width: 100%" v-model="form.schoolId" allowClear>
          <a-select-option v-for="(item, index) in schoolList" :value="item.id" :key="item.id">
            {{ item.schoolName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="stage" v-if="form.parentId==='0' ">
        <span slot="label"><a-tooltip>{{ $t('学段') }}<template slot="title">{{ $t('学段') }}</template></a-tooltip> </span>
        <a-select :placeholder="$t('请选择')+$t('学段')" style="width: 100%" v-model="form.stage" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.SchoolStageEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="gradeName">
        <span slot="label"><a-tooltip>{{ $t('年级名称') }}<template slot="title">{{ $t('年级名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.gradeName" :maxLength="255" :placeholder="$t('请输入')+'年级名称'">
        </a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort" >
        <a-input-number v-model="form.sort" :min="0" :max="9999999" style="width: 100%" :maxLength="32" :placeholder="$t('请输入')+$t('显示顺序')" />
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label"><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getSchoolGrade, addSchoolGrade, updateSchoolGrade} from '@/api/school/schoolGrade'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


export default {
  name: 'CreateForm',
  props: {
    schoolList:{
      require: true,
      type: Array,
    }
  },
  components: {
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        stage: undefined,
        gradeName: null,
        parentId: null,
        sort: 0,
        schoolId: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        gradeName: [{required: true, message: this.$t('年级名称') + this.$t('不能为空'), trigger: 'blur'}],
        parentId: [{required: true, message: this.$t('上级id') + this.$t('不能为空'), trigger: 'blur'}],
        stage: [{required: true, message: this.$t('学段') + this.$t('不能为空'), trigger: 'change'}],
        schoolId: [{required: true, message: this.$t('学校id') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        gradeName: null,
        stage: undefined,
        parentId: null,
        sort: 0,
        schoolId: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd(pid) {
      this.reset()
      this.form.parentId = pid;
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSchoolGrade({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSchoolGrade(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSchoolGrade(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
